<template>
	<div v-loading="loading">
		<div class="standalone-container">
			<div class="editor-container">
				<quill-editor 
					v-model="value"
					ref="myQuillEditor" 
					:options="editorOption"
					@change="onEditorChange($event)">
				</quill-editor>
			</div>
			<div class="count">{{TiLength}}/4000</div>
			<input 
				style="display: none" 
				ref="uploadInput" 
				type="file" 
				name="avator"
				multiple accept="image/jpg,image/jpeg,image/png"
				@change="handleUpload">
		</div>
	</div>
</template>

<script>
export default {
	props: ['qaValue'],
	data() {
		const toolbarOptions = [
			['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
			['blockquote'], // 引用
			[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
			[{ list: 'ordered' }, { list: 'bullet' }], // 列表
			[{ script: 'sub' }, { script: 'super' }], // 上下标
			[{ indent: '-1' }, { indent: '+1' }], // 缩进
			[{ direction: 'rtl' }], // 文本方向
			[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
			[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
			[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
			[{ font: [] }], // 字体
			[{ align: [] }], // 对齐方式
			['clean'], // 清除字体样式
			['image', 'video'] // 上传图片、上传视频
		];
		return {
			loading: false,
			isProd: process.env.NODE_ENV === 'production',
			editorOption: {
				placeholder: '请输入节点内容...',
                modules:{
                    imageResize: { 
                        displayStyles: {
                            backgroundColor: 'black',
                            border: 'none',
                            color: 'white'
                        },
                        modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
                    },
                    toolbar: {
						container: toolbarOptions
					},
					imageDropAndPaste: {
						handler: this.imageHandler
					}
                }
            },
			addImgRange: '',
			value: '',
			TiLength: 0,
			quill: null,
			image: {
				type: '', // image's mimeType
				dataUrl: null, // image's base64 string
				blob: null, // image's BLOB object
				file: null, // image's File object
			},
			blobUrl: null,
		}
	},
	mounted() {
        let self = this;
		self.TiLength = self.$refs.myQuillEditor.quill.getLength() - 1;
        /*处理富文本编辑器图片上传到OSS*/
        let imgHandler = async function (image) {
            self.addImgRange = self.$refs.myQuillEditor.quill.getSelection();
            if (image) {
                // let fileInput = document.getElementById('uploadInput'); //隐藏的file文本ID
				let fileInput = self.$refs.uploadInput;
                fileInput.click(); //加一个触发事件
            }
        }
        self.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", imgHandler);
    },
	created() {
		setTimeout(() => {
			this.value = this.qaValue;
		}, 500);
	},
	methods:{
		imageHandler(dataUrl, type, imageData) {
			/**
			 * Do something to our dropped or pasted image
			 * @param.imageDataUrl {string} - image's dataURL
			 * @param.type {string} - image's mime type
			 * @param.imageData {ImageData} - provided more functions to handle the image
			 *   - imageData.toBlob() {function} - convert image to a BLOB Object
			 *   - imageData.toFile(filename?: string) {function} - convert image to a File Object. filename is optional, it will generate a random name if the original image didn't have a name.
			 *   - imageData.minify(options) {function)- minify the image, return a promise
			 *      - options.maxWidth {number} - specify the max width of the image, default is 800
			 *      - options.maxHeight {number} - specify the max height of the image, default is 800
			 *      - options.quality {number} - specify the quality of the image, default is 0.8
			 */
			imageData.minify({}).then((miniImageData) => {
				const file = miniImageData.toFile();
				this.handleUpload(file, 'other');
			})
		},
		onEditorChange(event) {
			event.quill.deleteText(4000, 1);
			if(this.value === 0){
				this.TiLength = 0;
			}
			else{
				this.TiLength = event.quill.getLength() - 1;
			}
			let ashort = this.$refs.myQuillEditor.quill.getText().substring(0,200);
			this.$emit('childByValue', {
				value: this.value, 
				ashort: ashort
			});
		},
        handleUpload(e, type) {
            let self = this;
            let files = type === 'other' ? [e] : e.target.files;
            if (files.length == 0) return;
			if((files[0]?.size / 1024 / 1024) > 20) {
				self.$message.error('附件大于20M，请重新上传');
				return;
			}
			self.loading = true;
			const formData = new FormData();
			formData.append("brand", this.$store.getters.userInfo.brandIdentify);
			formData.append("servicename", 'knowledge');
			formData.append("cdn", self.isProd ? '1' : '0');
			formData.append('file', files[0]);
			self.$api.apiPostUploadFile(formData).then(response => {
				if(response.errcode != 0) {
					self.loading = false;
					return;
				}
				self.addImgRange = self.$refs.myQuillEditor.quill.getSelection();
				self.$refs.myQuillEditor.quill.insertEmbed(self.addImgRange != null ? self.addImgRange.index : 0, 'image', response.data.urlMark, Quill.sources.USER);
				self.loading = false;
			});
        }
    }
}
</script>

<style lang="scss" scoped>
.standalone-container {
	width: 100%;
}

::v-deep .ql-editor {
	min-height: 150px;
}

::v-deep .ql-toolbar {
	border: none;
	background: #f2f2f2;
	padding: 0;
	border-bottom: solid 1px #D8D8D8;
}

::v-deep .ql-snow .ql-formats {
	margin: 0;
	line-height: 22px;
}
::v-deep .ql-container {
	border: none !important;
}

.count {
	color: #909399;
	background: #fff;
	font-size: 12px;
	text-align: right;
	padding-right: 8px;
	box-sizing: border-box;
	line-height: 30px;
}

</style>